import weekIcon from 'src/public/img/illustration-puzzles.svg';
import congratulationsIcon from 'src/public/img/illustration-smiley-face.svg';

import { ProgramSharedStep, ProgramWeekEnum } from 'src/modules/programs/models/programs';

import { CBTProgramStepProps } from '../../models/cbtProgram';
import { ChallengeTheThoughtStep } from '../stepComponents/ChallengeTheThoughtStep';
import { CognitiveFlexibilityPracticeStep } from '../stepComponents/CognitiveFlexibilityPracticeStep';
import { DevelopingCognitiveFlexibilityStep } from '../stepComponents/DevelopingCognitiveFlexibilityStep';
import { HowDidMindfulnessOfEmotionsGoStep } from '../stepComponents/HowDidMindfulnessOfEmotionsGoStep';
import { IdentifyAnAlternativeThoughtStep } from '../stepComponents/IdentifyAnAlternativeThoughtStep';
import { LookingAtAlternativesStep } from '../stepComponents/LookingAtAlternativesStep';
import { ThoughtsCanBeUnhelpfulStep } from '../stepComponents/ThoughtsCanBeUnhelpful';
import { ThoughtsMatterStep } from '../stepComponents/ThoughtsMatterStep';
import { WhyFocusOnThoughtsStep } from '../stepComponents/WhyFocusOnThoughts';
import { YourExperienceOfThoughtsStep } from '../stepComponents/YourExperienceOfThoughtsStep';
import { CBTProgramWeekFiveStep } from './weekFive';

const steps: (ProgramSharedStep | CBTProgramWeekFiveStep)[] = [
    ProgramSharedStep.WellbeingCheckInStep,
    ProgramSharedStep.WellbeingScoreStep,
    ProgramSharedStep.FeedbackStep,
    CBTProgramWeekFiveStep.HowDidMindfulnessOfEmotionsGoStep,
    CBTProgramWeekFiveStep.WhyFocusOnThoughtsStep,
    CBTProgramWeekFiveStep.ThoughtsMatterStep,
    CBTProgramWeekFiveStep.YourExperienceOfThoughtsStep,
    CBTProgramWeekFiveStep.ThoughtsCanBeUnhelpfulStep,
    CBTProgramWeekFiveStep.DevelopingCognitiveFlexibilityStep,
    CBTProgramWeekFiveStep.LookingAtAlternativesStep,
    CBTProgramWeekFiveStep.ChallengeTheThoughtStep,
    CBTProgramWeekFiveStep.IdentifyAnAlternativeThoughtStep,
    ProgramSharedStep.PlanStep,
    ProgramSharedStep.CongratulationsStep,
];

const stepsProps: CBTProgramStepProps[] = [
    {
        id: CBTProgramWeekFiveStep.HowDidMindfulnessOfEmotionsGoStep,
        component: HowDidMindfulnessOfEmotionsGoStep,
        tooltip: 'How did mindfulness of emotions go last week?',
        noButtons: true,
    },
    {
        id: CBTProgramWeekFiveStep.WhyFocusOnThoughtsStep,
        component: WhyFocusOnThoughtsStep,
        tooltip: 'Why focus on thoughts?',
    },
    {
        id: CBTProgramWeekFiveStep.ThoughtsMatterStep,
        component: ThoughtsMatterStep,
        tooltip: 'Thoughts matter',
    },
    {
        id: CBTProgramWeekFiveStep.YourExperienceOfThoughtsStep,
        component: YourExperienceOfThoughtsStep,
        tooltip: 'Your experience of thoughts',
        noButtons: true,
    },
    {
        id: CBTProgramWeekFiveStep.ThoughtsCanBeUnhelpfulStep,
        component: ThoughtsCanBeUnhelpfulStep,
        tooltip: 'Thoughts can be unhelpful',
    },
    {
        id: CBTProgramWeekFiveStep.DevelopingCognitiveFlexibilityStep,
        component: DevelopingCognitiveFlexibilityStep,
        tooltip: 'Developing cognitive flexibility',
    },
    {
        id: CBTProgramWeekFiveStep.LookingAtAlternativesStep,
        component: LookingAtAlternativesStep,
        tooltip: 'Looking at alternatives',
        noButtons: true,
    },
    {
        id: CBTProgramWeekFiveStep.ChallengeTheThoughtStep,
        component: ChallengeTheThoughtStep,
        tooltip: 'Challenge the thought',
    },
    {
        id: CBTProgramWeekFiveStep.IdentifyAnAlternativeThoughtStep,
        component: IdentifyAnAlternativeThoughtStep,
        tooltip: 'Identify an alternative thought',
        noButtons: true,
    },
    {
        id: ProgramSharedStep.PlanStep,
        component: CognitiveFlexibilityPracticeStep,
        tooltip: 'This week',
        flexGrow: false,
    },
];

const t = (key: string) => `cbt:week-5.data.${key}`;

export const weekFiveData = {
    id: ProgramWeekEnum.WeekFive,
    weekNumber: 4,
    readableWeekNumber: 5,
    iconUrl: weekIcon,
    congratulationsIconUrl: congratulationsIcon,
    title: t('title'),
    congratulationsSneakPeek: t('congratulationsSneakPeek'),
    feedbackPlaceholder: t('feedbackPlaceholder'),
    greetingModalContent: t('greetingModalContent'),
    steps,
    stepsProps,
};
